const requests = new Map();

export default function getForecastWidgetData(coinId) {
    if (!requests.has(coinId)) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        const request = fetch(ajaxurl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
            body: new URLSearchParams({ action: 'get_forecast_widget_data', id: coinId }),
            signal: controller.signal,
        }).then(async response => {
            if (!response.ok) throw new Error(`Forecast request failed: ${response.status}`);
            const result = await response.json();
            if (!result.success || !result.data) throw new Error('Invalid forecast response');
            return result.data;
        }).catch(error => {
            requests.delete(coinId);
            throw error;
        }).finally(() => clearTimeout(timeout));

        requests.set(coinId, request);
    }

    return requests.get(coinId);
}
